import styled from 'styled-components'
import { Columns } from 'components/flex'
import { HalfNakedButton } from 'components/button'

export const HeroColumns = styled(Columns)`
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`

export const TitleColumns = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    column-gap: 16px;
`

export const ActionColumn = styled.div`
    position: relative;
`

export const ExportButton = styled(HalfNakedButton)`
    padding: 0 8px;
    color: var(--huma-color-foreground-constructive-bold);

    &:where(:hover, :focus) {
        color: var(--huma-color-foreground-constructive-bold-active);
    }
`
